import tokens from '../tokens/radius-tokens.json';
import { RadiusTokensEnum } from '../../enums/tokens/radiusTokensEnum';

export const radiusTokens = tokens;

export const radii: Record<string, string> = Object.entries(tokens).reduce(
  (acc, [name, token]) => ({ ...acc, [name]: token.value }),
  {}
);

export const radiusOptions = Object.keys(radii);

/** Rule of thumb: when in doubt, use radius-md. */
export const DEFAULT_RADIUS = RadiusTokensEnum.MD;

/**
 * Square corners. Not a brand token - it is only offered on the playground
 * controls so full-bleed surfaces (page banners) can be previewed.
 */
export const NO_RADIUS_OPTION = 'none';
const NO_RADIUS_VALUE = '0px';

export const radiusControlOptions = [NO_RADIUS_OPTION, ...radiusOptions];

export const radiusControlMapping: Record<string, string> = {
  [NO_RADIUS_OPTION]: NO_RADIUS_VALUE,
  ...radii,
};

/** Turns a radius token name into its CSS value, passing raw CSS through untouched. */
export const resolveRadius = (radius?: string): string =>
  radiusControlMapping[radius as string] || radius || NO_RADIUS_VALUE;
